import { HStack, SimpleGrid, Stack, Tooltip } from "@chakra-ui/react"
import { Text } from "@/components"
import { Deal } from "@/types"
import { IoInformationCircleOutline } from "react-icons/io5"

interface Props {
  currentDeal: Deal
}

const formatCurrency = (cents: number | null | undefined) => {
  if (cents == null) return "—"
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(cents / 100)
}

const InfoTooltip = ({ label }: { label: string }) => (
  <Tooltip.Root positioning={{ placement: "right" }}>
    <Tooltip.Trigger asChild>
      <span style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }}>
        <IoInformationCircleOutline size={16} color="gray" />
      </span>
    </Tooltip.Trigger>
    <Tooltip.Positioner>
      <Tooltip.Content>
        {label}
      </Tooltip.Content>
    </Tooltip.Positioner>
  </Tooltip.Root>
)

export const DealSummarySection = ({ currentDeal }: Props) => {
  const acceptedOffer = currentDeal.offers?.find(o => o.isAccepted)
  const activeOffer = acceptedOffer ?? currentDeal.offers?.[0]

  return (
    <Stack>
      <Text fontSize="lg" fontWeight="semibold">
        Deal Summary — {currentDeal.company.name}
      </Text>
      <SimpleGrid columns={{ base: 1, md: 2 }} gap={4} mt={2}>
        <Stack
          p={5}
          borderWidth="1px"
          borderRadius="lg"
          borderColor="gray.200"
        >
          <HStack gap={1}>
            <Text fontSize="sm" color="gray.500">
              Exercise Cost
            </Text>
            <InfoTooltip label="Exercise Cost includes NSO Taxes and Options Cost" />
          </HStack>
          <Text fontSize="2xl" fontWeight="bold">
            {formatCurrency(activeOffer?.exerciseCost)}
          </Text>
        </Stack>
        <Stack
          p={5}
          borderWidth="1px"
          borderRadius="lg"
          borderColor="gray.200"
        >
          <HStack gap={1}>
            <Text fontSize="sm" color="gray.500">
              Additional Liquidity
            </Text>
            <InfoTooltip label="This may include coverage for AMT" />
          </HStack>
          <Text fontSize="2xl" fontWeight="bold">
            {formatCurrency(activeOffer?.desiredLiquidity)}
          </Text>
        </Stack>
      </SimpleGrid>
    </Stack>
  )
}
